import { useState, useCallback } from "react";
import { ResultsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useUploadHistory() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();

  const fetchUploadHistory = useCallback(async (compYearUSEFCompID) => {
    if (!compYearUSEFCompID || !auth.user?.access_token) {
      throw new Error("Missing required parameters");
    }

    setLoading(true);
    setError(null);

    try {
      const api = new ResultsApi(
        new Configuration({
          basePath: MANAGER_API_BASE_URL,
          accessToken: auth.user.access_token,
        })
      );

      const response = await api.getUploadHistory(compYearUSEFCompID);

      return response.data || [];
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        "Failed to fetch upload history";
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [auth.user?.access_token]);

  const getDownloadUrl = useCallback(async (s3Path) => {
    if (!s3Path || !auth.user?.access_token) {
      throw new Error("Missing required parameters");
    }

    try {
      const api = new ResultsApi(
        new Configuration({
          basePath: MANAGER_API_BASE_URL,
          accessToken: auth.user.access_token,
        })
      );

      const response = await api.getUploadDownloadUrl(s3Path);
      return response.data?.url;
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        "Failed to generate download URL";
      throw new Error(errorMessage);
    }
  }, [auth.user?.access_token]);

  return { fetchUploadHistory, getDownloadUrl, loading, error };
}
